import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import ReactAudio from 'react-h5-audio-player';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Button } from '../../_atoms/Button';
import { Frame } from '../../_molecules/Frame';
import { ImageButton } from '../../_molecules/ImageButton';

const BookNum = styled.div`
  position: absolute;
  top: 335px;
  left: 50%;
  transform: translateX(-50%);
  width: 110px;
  height: 110px;
  border-radius: 55px;
  border: 10px solid #fff;
  font-size: 70px;
  font-weight: 700;
  color: #fff;
  line-height: 100px;
  text-align: center;
  background-color: #fa776d;
`;

const AudioPlayer = styled(ReactAudio)`
  width : 0;
  height : 0;
  opacity: 0;
  display: none;
`;

export const MenuTemplate = (props) => {
  const state = useSelector((state) => state);
  const player = useRef();
  const buttonPlayer = useRef();

  const [play, setPlay] = useState(false);

  useEffect(() => {
    player.current.audio.current.pause();

    play ? player.current.audio.current.play() : player.current.audio.current.pause();
  }, [play]);

  const onMouseOver = () => {
    buttonPlayer.current.audio.current.play();
  };

  return (
    <Frame type='menu'>
      <BookNum>{state.book.current_book + 1}</BookNum>
      <Button type='menu' animal='rabbit' onClick={() => window.location.hash="#/audio"} onMouseOver={onMouseOver}/>
      <Button type='menu' animal='fox' onClick={() => window.location.hash="#/ebook"} onMouseOver={onMouseOver}/>
      <ImageButton
        type="home"
        src="https://content.chungchy.com/PhonicsHero/web_resource/images/common/btn_home_150px.png"
        alt="HOME"
        onClick={() => window.location.hash="#/"}
      />
      <AudioPlayer 
        ref={player}
        src="https://content.chungchy.com/PhonicsHero/web_resource/mp3/homebgm_Bike_Rides.mp3"
        preload="true"
        showSkipControls={true}
        showJumpControls={false}
        loop={true}
        onLoadedMetaData={() => {
          setPlay(true);
        }}
      />
      <AudioPlayer 
        ref={buttonPlayer}
        src="https://content.chungchy.com/PhonicsHero/web_resource/mp3/btn.wav"
        preload="true"
        showSkipControls={true}
        showJumpControls={false}
        onLoadedMetaData={() => {
          buttonPlayer.current.audio.current.pause();
        }}
      />
    </Frame>
  );
};

MenuTemplate.propTypes = {
  animal : PropTypes.string.isRequired
};

MenuTemplate.defaultProps = {
  animal : 'rabbit'
};